import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24df84a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slotModal__overlay" }, null, -1))
const _hoisted_2 = { class: "slotModal__frame" }
const _hoisted_3 = { class: "slotModal__inner" }
const _hoisted_4 = { class: "slotModal__close_icon" }
const _hoisted_5 = {
  key: 0,
  class: "slotModal__head"
}
const _hoisted_6 = {
  key: 0,
  class: "slotModal__icon"
}
const _hoisted_7 = { class: "slotModal__title" }
const _hoisted_8 = ["data-loading"]
const _hoisted_9 = { class: "slotModal__contents_inner" }
const _hoisted_10 = ["data-loading"]

import {
  withDefaults,
  computed,
  ref,
  toRefs,
  watch,
  onMounted,
} from 'vue'

import { sleep } from '@/utils'

import { useKeyboardStore } from '@/store/keyboard'
import { LoadingStore, useLoadingStore, loadingReset } from '@/store/loading'

import AppLoading from '@/components/AppLoading/AppLoading.vue'
import AnimationPushToShadow from '@/components/AnimationPushToShadow/AnimationPushToShadow.vue'
import AppImage from '@/components/AppImage/AppImage.vue'

interface Props {
  fillHeight?: boolean
  icon?: string
  button?: boolean
  fit?: boolean
  loading?: boolean
  keyboard?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SlotModal',
  props: {
    fillHeight: { type: Boolean, default: true },
    icon: { default: '' },
    button: { type: Boolean, default: true },
    fit: { type: Boolean, default: false },
    loading: { type: Boolean, default: true },
    keyboard: { type: Boolean, default: true }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { fillHeight: boolean, icon: string, button: boolean, fit: boolean, loading: boolean, keyboard: boolean }



// 閉じるボタンの表示監視
const isButtonShow = ref<boolean>(true)
const { button } = toRefs(props)
watch(button, (res) => {
  isButtonShow.value = res
})



const close = () => {
  setModalHeightOver()
  emit('close')
}

// モーダルの高さを計算
const isModalHeightOver = ref<boolean>(false)
const setModalHeightOver = (state = false) => {
  isModalHeightOver.value = state
}
const calcModalHeight = () => {
  // props.keyboardがfalseの場合は処理しない
  if (!props.keyboard) return
  // 既に設定されていたら処理しない
  if (isModalHeightOver.value) return
  const wrapper = document.querySelectorAll('.slotModal__wrapper')
  wrapper.forEach((el) => {
    const contains = el.classList.contains('is-fit')
    const modalAreaHeight = el?.clientHeight || 0
    const modalHeight = el.querySelector('.slotModal__frame')?.clientHeight || 0

    // 既に設定されていたら処理しない
    if (contains) {
      setModalHeightOver(true)
      return
    }
    // モーダルの高さがモーダルエリアの高さを超えていたら
    if (!isModalHeightOver.value && modalAreaHeight < modalHeight) {
      setModalHeightOver(true)
    }
  })
}

// ソフトキーボードが表示されているか
const keyboardStore = useKeyboardStore()
const isKeyboardShow = computed(() => keyboardStore.getShow)
keyboardStore.$subscribe(async (mutation, state) => {
  if (state.isShow) {
    await sleep(200)
    // モーダルの高さを計算
    setModalHeightOver()
    calcModalHeight()
  }
})

// ローディング
const loadingStore = useLoadingStore()
const loadingState = ref<LoadingStore>()
loadingStore.$subscribe(async (mutation, state) => {
  // nameで設定
  loadingState.value = state.name === 'modal' ? loadingReset : undefined
  // モーダルの高さを計算
  calcModalHeight()
})
// 初回
loadingState.value = loadingStore.getLoadingState

onMounted(() => {
  // モーダルの高さを計算
  calcModalHeight()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slotModal", { 'is-noKeyboard': !__props.keyboard }])
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["slotModal__wrapper", {
        'no-head': !_ctx.$slots.title,
        'no-actionArea': !_ctx.$slots.actionArea,
        'is-fillHeight': __props.fillHeight,
        'is-fit': __props.fit || isModalHeightOver.value,
        isKeyboardShow: _unref(isKeyboardShow),
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["slotModal__close", { 'is-hide': !isButtonShow.value }]),
            onClick: close
          }, [
            _createVNode(AnimationPushToShadow, {
              tag: "button",
              backgroundColor: "#eaeef4",
              shadowColor: "#93a8b5",
              rounded: "circle"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(AppImage, {
                    src: require('@/assets/image/icon/icon_close.svg'),
                    alt: "とじる"
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            })
          ], 2),
          (_ctx.$slots.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (__props.icon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(AppImage, {
                        src: __props.icon,
                        noImageSrc: require('@/assets/image/img_book_404.svg'),
                        alt: "",
                        width: "36",
                        height: "36"
                      }, null, 8, ["src", "noImageSrc"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "title")
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "slotModal__contents",
                "data-loading": loadingState.value?.loading
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                (__props.loading)
                  ? (_openBlock(), _createBlock(_Transition, {
                      key: 0,
                      name: "fade"
                    }, {
                      default: _withCtx(() => [
                        (loadingState.value && loadingState.value.loading)
                          ? (_openBlock(), _createBlock(AppLoading, {
                              key: 0,
                              type: loadingState.value.type,
                              class: _normalizeClass({
                  'is-head': _ctx.$slots.title,
                  noActionArea: !_ctx.$slots.actionArea,
                })
                            }, null, 8, ["type", "class"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.$slots.actionArea)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "slotModal__actionArea",
                "data-loading": loadingState.value?.loading
              }, [
                _renderSlot(_ctx.$slots, "actionArea")
              ], 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ], 2))
}
}

})